export const gapStyles = {
    XXL: 'gap-6xl',
    XL: 'gap-5xl',
    L: 'gap-3xl',
    M: 'gap-m',
    S: 'gap-xs',
    XS: 'gap-2xs',
    '': '',
};
//# sourceMappingURL=gapStyles.js.map